/* esm.sh - applesauce-loaders@5.1.0/dist/helpers/event-pointer */
export * from "/*applesauce-loaders@5.1.0/esnext/dist/helpers/event-pointer.mjs";
